import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from "recharts";
import { adSpendSeries } from "@/mocks/seed";

export function AdSpendChart() {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={adSpendSeries} margin={{ top: 8, right: 8, left: -10, bottom: 0 }}>
        <CartesianGrid stroke="rgba(255,255,255,0.04)" vertical={false} />
        <XAxis dataKey="month" tick={{ fill: "#4a4e62", fontSize: 10 }} axisLine={false} tickLine={false} />
        <YAxis
          tick={{ fill: "#4a4e62", fontSize: 10 }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(v: number) => `$${(v / 1000).toFixed(0)}k`}
        />
        <Tooltip
          cursor={{ fill: "rgba(255,255,255,0.03)" }}
          contentStyle={{ background: "#171d2a", border: "1px solid rgba(226,232,255,0.13)", borderRadius: 11, fontSize: 12 }}
          labelStyle={{ color: "#e8eaf2" }}
        />
        <Bar dataKey="usd" name="Dépenses USD" radius={[5, 5, 0, 0]}>
          {adSpendSeries.map((_, i) => (
            <Cell key={i} fill={i === adSpendSeries.length - 1 ? "#6d7cff" : "rgba(109,124,255,0.28)"} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
